import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {AuthGuard} from './helpers/auth.guard';

const lng = typeof navigator !== 'undefined' && navigator.language?.split('-')[0] === 'fr' ? 'fr' : 'en';

export const routes: Routes = [
  { path: 'visa-subscription/en', redirectTo:'errors', pathMatch: 'full'},
  { path: 'visa-subscription/fr', redirectTo:'errors', pathMatch: 'full'},
  { path: 'partners/erasmus-play', loadComponent: () => import('./pages/reports/erasmus-play/erasmus-play.component').then(mod => mod.ErasmusPlayComponent)},
  { path: 'documents/validation/:docKey',loadComponent: () => import('./pages/users/document-validation/document-validation.component').then(mod => mod.DocumentValidationComponent)},
  { path: 'admin',loadChildren: () => import('./admin/app-backcare.module').then(m => m.AppBackcareModule)},
  { path: 'sitemap',  loadComponent: () => import('./pages/sitemap/sitemap.component').then(mod => mod.SitemapComponent)},
  {
    path: 'login',
    loadComponent: () => import('./pages/registration/registration.component').then(mod => mod.RegistrationComponent)
  },
  { path: 'register', loadComponent: () => import('./pages/registration/registration.component').then(mod => mod.RegistrationComponent)},
  { path: 'accommodation', redirectTo: lng + '/accommodation', pathMatch: 'full' },
  {
    path: 'fr/cgu',
    loadComponent: () => import('./pages/blog/pages-template/pages-template.component').then(mod => mod.PageTemplateComponent),
    data: {
      pageTitle: 'PAGE TEMPLATE',
      hasFooter: true,
      hasHeader: true,
      pathMatch: 'full',
      type: 'urldirect',
    }
  },
  {
    path: 'en/gcu',
    loadComponent: () => import('./pages/blog/pages-template/pages-template.component').then(mod => mod.PageTemplateComponent),
    data: {
      pageTitle: 'PAGE TEMPLATE',
      hasFooter: true,
      hasHeader: true,
      pathMatch: 'full',
      type: 'urldirect',
    }
  },
  {
    path: 'fr/politique-de-confidentialite',
    loadComponent: () => import('./pages/blog/pages-template/pages-template.component').then(mod => mod.PageTemplateComponent),
    data: {
      pageTitle: 'PAGE TEMPLATE',
      hasFooter: true,
      hasHeader: true,
      pathMatch: 'full',
      type: 'urldirect',
    }
  },
  {
    path: 'en/privacy-policy',
    loadComponent: () => import('./pages/blog/pages-template/pages-template.component').then(mod => mod.PageTemplateComponent),
    data: {
      pageTitle: 'PAGE TEMPLATE',
      hasFooter: true,
      hasHeader: true,
      pathMatch: 'full',
      type: 'urldirect',
    }
  },
  {
    path: 'fr/mentions-legales',
    loadComponent: () => import('./pages/blog/pages-template/pages-template.component').then(mod => mod.PageTemplateComponent),
    data: {
      pageTitle: 'PAGE TEMPLATE',
      hasFooter: true,
      hasHeader: true,
      pathMatch: 'full',
      type: 'urldirect',
    }
  },
  {
    path: 'en/legal-notice',
    loadComponent: () => import('./pages/blog/pages-template/pages-template.component').then(mod => mod.PageTemplateComponent),
    data: {
      pageTitle: 'PAGE TEMPLATE',
      hasFooter: true,
      hasHeader: true,
      pathMatch: 'full',
      type: 'urldirect',
    }
  },

  {
    path: ':schoolSlug/login',
    loadComponent: () => import('./pages/registration/registration.component').then(mod => mod.RegistrationComponent)
  },
  { path: ':schoolSlug/register', loadComponent: () => import('./pages/registration/registration.component').then(mod => mod.RegistrationComponent)},
  { path: 'feeds/erasmus_play',
    loadComponent: () => import('./components/external-redirect/external-redirect.component').then(mod => mod.ExternalRedirectComponent),
    pathMatch: 'full'
  },

  {
    path: 'browse',
    loadComponent: () => import('./shared/layout/side-navbar/admin-sidenav.component').then(mod => mod.AdminSidenavComponent),
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        loadComponent: () => import('./pages/dashboard/dashboard.component').then(mod => mod.DashboardComponent),
        data: {
          hasFooter: true,
          pageTitle: 'HEADER.DASHBOARD',
          activeTab: 'explore'
        },
      }
    ],
    data: {
      margin: false,
    }
  },
  // @TODO rename/config
  {
    path: 'page/:slug',
    loadComponent: () => import('./pages/blog/pages-template/pages-template.component').then(mod => mod.PageTemplateComponent),
    data: {
      pageTitle: 'PAGE TEMPLATE',
      hasFooter: true,
      hasHeader: true,
      type: 'page',
    }
  },

  {
    path: ':lang/blog',
    children: [
      {
        path: '',
        loadComponent: () => import('./pages/blog/blog.component').then(mod => mod.BlogComponent),
        data: {
          pageTitle: 'PAGE TEMPLATE',
          hasFooter: false,
          hasHeader:false,
          type: 'blog',
        },
      },
      {
        path: ':slug',
        loadComponent: () => import('./pages/blog/blog-template/blog-template.component').then(mod => mod.BlogTemplateComponent),
        data: {
          parent: 'blog',
          pageTitle: 'PAGE TEMPLATE',
          hasFooter: false,
          hasHeader:false,
        },
      },
    ],
    data: {
      margin: false,
    }
  },
  {
    path: 'errors',
    loadComponent:() => import('./pages/error-page/error-page.component').then(mod => mod.NotFoundComponent),
  },
  /*
  {
    path: ':lang/news',
    children: [
      {
        path: '',
        loadComponent: () => import('./pages/blog/blog-template/blog-template.component').then(mod => mod.BlogTemplateComponent),
        data: {
          pageTitle: 'PAGE TEMPLATE',
          hasFooter: false,
          hasHeader:false,
          type: 'news',
          },
          },
          {
          path: ':slug',
          loadComponent: () => import('./pages/blog/blog-template/blog-template.component').then(mod => mod.BlogTemplateComponent),
          data: {
            parent: 'news',
            pageTitle: 'PAGE TEMPLATE',
            hasFooter: false,
            hasHeader:false,
            },
            },
            ],
      data: {
        margin: false,
        }
        },

        {
          path: ':lang/modeles',
          children: [
            {
          path: '',
          loadComponent: () => import('./pages/blog/blog-template/blog-template.component').then(mod => mod.BlogTemplateComponent),
          data: {
            pageTitle: 'PAGE TEMPLATE',
            hasFooter: false,
            hasHeader:false,
            type: 'modeles',
            },
            },
            {
              path: ':slug',
              loadComponent: () => import('./pages/blog/blog-template/blog-template.component').then(mod => mod.BlogTemplateComponent),
              data: {
                parent: 'modeles',
                pageTitle: 'PAGE TEMPLATE',
                hasFooter: false,
                hasHeader:false,
                },
                },
                ],
                data: {
                  margin: false,
                  }
                  },*/

  {
                    path: 'article',
                    children: [
                      {
                        path: ':slug',
                        loadComponent: () => import('./pages/blog/pages-template/pages-template.component').then(mod => mod.PageTemplateComponent),
                        data: {
                          pageTitle: 'PAGE TEMPLATE',
                          hasFooter: false,
                          hasHeader:false,
                          type: 'article',
                        },
                      }
    ],
    data: {
      margin: false,
    }
  },
  {
    path: 'redirect',
    loadComponent: () => import('./pages/redirect-waiting-page/redirect-waiting-page.component').then(mod => mod.RedirectWaitingPageComponent),
    data: {
      hasFooter: false,
      pageTitle: '{COMMON.REDIRECT.HEADER}',
    },
  },
  {
    path: 'account',
    loadComponent: () => import('./shared/layout/side-navbar/admin-sidenav.component').then(mod => mod.AdminSidenavComponent),
    canActivate: [AuthGuard],
    children: [
      {
        path: 'school',
        loadComponent: () => import('./pages/school-page/school-page.component').then(mod => mod.SchoolPageComponent),
        data: {
          pageTitle: 'HEADER.MY_SCHOOL',
        }
      } ,
      {
        path: ':process/partners',
        loadComponent: () => import('./pages/partners/partners.component').then(mod => mod.PartnersComponent),
        data: {
          hasFooter: false,
          pageTitle: false,
        },
      },
    ] ,
    data: {
      margin:false
    }
  },
  {
    path: 'account',
    loadComponent: () => import('./shared/layout/side-navbar/admin-sidenav.component').then(mod => mod.AdminSidenavComponent),
    canActivate: [AuthGuard],
    children: [
      {
        path: 'my-profile',
        loadComponent: () => import('./pages/users/profile/profile.component').then(mod => mod.ProfileComponent),
        data: {
          hasFooter: true,
          pageTitle: 'HEADER.MY_ACCOUNT',
          notification: 'my-profile',
        },
      },
      {
        path: 'dashboard',
        loadComponent: () => import('./pages/dashboard/dashboard.component').then(mod => mod.DashboardComponent),
        data: {
          hasFooter: true,
          pageTitle: 'HEADER.DASHBOARD',
        },
      },
      {
        path: 'health_insurance/process',
        loadComponent: () => import('./pages/processes/health-insurance/health-insurance.component').then(mod => mod.HealthInsuranceComponent),
        data: {
          hasFooter: false,
          pageTitle: 'PROCESSES.HEALTH_INSURANCE.TITLE',
        },
      },
      {
        path: 'avi/document',
        loadComponent: () => import('./pages/processes/avi/avi.component').then(mod => mod.AviComponent),
        data: {
          hasFooter: false,
          pageTitle: 'PROCESSES.AVI.TITLE',
        }
      },
      {
        path: 'accommodation_partners/process',
        loadComponent: () => import('./pages/processes/accommodation/accommodation.component').then(mod => mod.AccommodationComponent),
        data: {
          hasFooter: false,
          pageTitle: 'PROCESSES.ACCOMMODATION_PARTNERS.TITLE',
        },
      },
      {
        path: 'cvec',
        data: {
          hasFooter: false,
          pageTitle: 'PROCESSES.CVEC.TITLE',
        },
        children: [
          { path: 'eligibility', loadComponent: () => import('./pages/processes/cvec/cvec-eligibility/cvec-eligibility.component').then(mod => mod.CvecEligibilityComponent)},
          { path: 'process', loadComponent: () => import('./pages/processes/cvec/cvec-process/cvec-process.component').then(mod => mod.CvecProcessComponent)},
        ]},
        { path: 'visa',
          data: {
            pageTitle: 'PROCESSES.VISA.TITLE',
          hasFooter: false,},
          children: [
            { path: 'start', loadComponent: () => import('./pages/processes/visa/visa-home/visa-home.component').then(mod => mod.VisaHomeComponent)},
            { path: 'informations', loadComponent: () => import('./pages/processes/visa/visa-layout/visa-layout.component').then(mod => mod.VisaLayoutComponent)},
            { path: 'result', loadComponent: () => import('./pages/processes/visa/visa-layout/visa-layout.component').then(mod => mod.VisaLayoutComponent)},
            { path: 'files', loadComponent: () => import('./pages/processes/visa/visa-layout/visa-layout.component').then(mod => mod.VisaLayoutComponent)},
            { path: 'appointment', loadComponent: () => import('./pages/processes/visa/visa-layout/visa-layout.component').then(mod => mod.VisaLayoutComponent)},
            { path: 'validation', loadComponent: () => import('./pages/processes/visa/visa-layout/visa-layout.component').then(mod => mod.VisaLayoutComponent)},
            { path: '**', loadComponent: () => import('./pages/processes/visa/visa-home/visa-home.component').then(mod => mod.VisaHomeComponent)}
          ]},
      {
        path: 'caf',
        data: {
          hasFooter: false,
          pageTitle: 'PROCESSES.CAF.TITLE',
        },
        children: [
          { path: 'eligibility', loadComponent: () => import('./pages/processes/caf/eligibility/eligibility.component').then(mod => mod.CafEligibilityComponent)},
          { path: 'process', loadComponent: () => import('./pages/processes/caf/process/process.component').then(mod => mod.CafProcessComponent)},
        ]},
      ],
    },
    {
      path: ':lang',
      children: [
        {
          path: 'discover',
          loadComponent: () => import('./shared/layout/side-navbar/admin-sidenav.component').then(mod => mod.AdminSidenavComponent),
          canActivate: [AuthGuard],
          children: [
            {
              path: '',
              loadComponent: () => import('./pages/dashboard/dashboard.component').then(mod => mod.DashboardComponent),
              data: {
                hasFooter: true,
                pageTitle: 'HEADER.DASHBOARD',
                activeTab: 'discover'
              },
            }
          ],
          data: {
            margin: false,
          }
        },
        { path: 'accommodation', loadChildren: () => import('./pages/processes/accommodation/accommodation.module').then(m => m.AccommodationModule)},
        { path: 'housing-certificate',loadChildren: () => import('./pages/processes/housing-certificate/housing-certificate.module').then(m => m.HousingCertificateRoutingModule)},
        { path: 'school/:slug', redirectTo:':slug/register', pathMatch: 'full'},
        {
          path: ':schoolSlug',
          children: [
            { path: 'register', loadComponent: () => import('./pages/registration/registration.component').then(mod => mod.RegistrationComponent)},
            {
              path: 'login',
              loadComponent: () => import('./pages/registration/registration.component').then(mod => mod.RegistrationComponent)
            },
            {
              path: 'reset_password',
              loadComponent: () => import('./pages/password-recover/reset-password/reset-password.component').then(mod => mod.ResetPasswordComponent)
            },
            {
              path: '',
              loadComponent: () => import('./pages/registration/registration.component').then(mod => mod.RegistrationComponent)      }
            ],
          },
          { path: '', loadComponent: () => import('./shared/components/home-page/home-page.component').then(mod => mod.HomePageComponent)},
      ]
    },

      { path: '', redirectTo: '/' + lng, pathMatch: 'full' },
      { path: '**', redirectTo: '/' + lng, pathMatch: 'full' }
    ];
    @NgModule({
      imports: [
        RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'enabled',
      anchorScrolling: 'enabled',
      scrollOffset: [0, 88]}),
    ],
    exports: [RouterModule],
  })
  export class AppRoutingModule {}
